// removed by extract-text-webpack-plugin
module.exports = {"horizontalCenter":"horizontalCenter__3Pva6","loaderText":"loaderText__1xcGY"};


//////////////////
// WEBPACK FOOTER
// ./components/submitButton/style.css
// module id = GRKX
// module chunks = 308 319 320 327 328 338 349 351